/*
 * @Author: wzh
 * @LastEditTime: 2023-03-17 10:37:31
 * @Description: auth 移动端路由 可不登陆访问的路由
 */
export default [
	// 移动登录
	{
		path: "/mlogin",
		name: "login",
		component: () => import("@/views/mViews/login/Login.vue"),
		meta: {
			notRequireAuth: true,
		},
	},
	// 完善资料
	{
		path: "/mperfectInfo",
		name: "PerfectInfo",
		component: () => import("@/views/mViews/loginAuth/PerfectInfo.vue"),
		meta: {
			title: "完善资料",
			field: "perfect_info",
			isShowArrow: false,
			notRequireAuth: true,
		},
	},
	// 信息防遗忘
	{
		path: "/mforgotten",
		name: "forgotten",
		component: () => import("@/views/mViews/loginAuth/Forgotten.vue"),
		meta: {
			title: "信息防遗忘",
			field: "forgotten",
			isShowArrow: false,
			notRequireAuth: true,
		},
	},
	// 二次认证
	{
		path: "/msecondAuth",
		name: "SecondAuth",
		component: () => import("@/views/mViews/loginAuth/SecondAuth.vue"),
		meta: {
			title: "二次认证",
			field: "second_auth",
			isShowArrow: false,
			notRequireAuth: true,
		},
	},
	// 修改密码
	{
		path: "/mupdatePassword",
		name: "UpdatePassword",
		component: () => import("@/views/mViews/home/Password.vue"),
		meta: {
			title: "修改密码",
			field: "update_password",
			isShowArrow: false,
			notRequireAuth: true,
		},
	},
	// 单处登录
	{
		path: "/msimplyLogin",
		name: "SimplyLogin",
		component: () => import("@/views/mViews/loginAuth/SimplyLogin.vue"),
		meta: {
			title: "单处登录",
			field: "simply_login",
			notRequireAuth: true,
		},
	},
	//安全问题找回密码
	{
		path: "/mproblem",
		name: "Problem",
		component: () => import("@/views/mViews/setPassword/Problem.vue"),
		meta: {
			title: "安全问题找回密码",
			field: "problem",
			isShowArrow: true,
			notRequireAuth: true,
		},
	},
	//实人认证(未使用)
	{
		path: "/mauthentica",
		name: "Authentica",
		component: () => import("@/views/mViews/setPassword/Authentica.vue"),
		meta: {
			title: "实人认证",
			isShowArrow: true,
			notRequireAuth: true,
		},
	},
	//绑定手机号
	{
		path: "/mbindPhone",
		name: "BindPhone",
		component: () => import("@/views/mViews/home/BindPhone.vue"),
		meta: {
			title: "绑定手机号",
			field: "bind_phone",
			isShowArrow: true,
			notRequireAuth: true,
		},
		beforeEnter(to, from, next) {
			const type = to.query.type;
			if (type === "forget") {
				to.meta.title = "手机号找回密码";
				to.meta.field = "forget_phone";
			} else if (type === "activate") {
				to.meta.title = "手机号激活";
				to.meta.field = "activate_phone";
			} else {
				to.meta.title = "绑定手机号";
				to.meta.field = "bind_phone";
			}
			next();
		},
	},
	//绑定邮箱
	{
		path: "/mbindEmail",
		name: "BindEmail",
		component: () => import("@/views/mViews/home/BindEmail.vue"),
		meta: {
			title: "绑定邮箱",
			field: "bind_email",
			isShowArrow: true,
			notRequireAuth: true,
		},
		beforeEnter(to, from, next) {
			const type = to.query.type;
			if (type === "forget") {
				to.meta.title = "邮箱找回密码";
				to.meta.field = "forget_email";
			} else if (type === "activate") {
				to.meta.title = "邮箱激活";
				to.meta.field = "activate_email";
			} else {
				to.meta.title = "绑定邮箱";
				to.meta.field = "bind_email";
			}
			next();
		},
	},
	// 设置新密码
	{
		path: "/mnewPassword",
		name: "NewPassword",
		component: () => import("@/views/mViews/setPassword/NewPassword.vue"),
		meta: {
			title: "设置新密码",
			field: "new_password",
			isShowArrow: true,
			notRequireAuth: true,
		},
	},
	// 设置密码成功或失败
	{
		path: "/mwarnPassword",
		name: "WarnPassword",
		component: () => import("@/views/mViews/setPassword/WarnPassword.vue"),
		meta: {
			title: "设置密码",
			field: "warn_password",
			isShowArrow: true,
			notRequireAuth: true,
		},
	},
	// 忘记密码
	{
		path: "/mforget",
		name: "forget",
		redirect: "/mforget/wayBack",
		component: () => import("@/views/mViews/forget/Index.vue"),
		children: [
			{
				path: "/mforget/wayBack", // 找回方式
				name: "wayBack",
				component: () => import("@/views/mViews/forget/WayBack.vue"),
				meta: {
					title: "选择找回密码方式",
					field: "forget_way",
					isShowArrow: true,
					notRequireAuth: true,
				},
			},
			{
				path: "/mforget/verifyInfo", // 信息校验
				name: "verifyInfo",
				component: () => import("@/views/mViews/forget/VerifyInfo.vue"),
				meta: {
					title: "校验个人信息",
					field: "verify_info",
					isShowArrow: true,
					notRequireAuth: true,
				},
			},
			,
		],
	},
	// 账号激活
	{
		path: "/mactivate",
		name: "Activate",
		redirect: "/mactivate/wayBack",
		component: () => import("@/views/mViews/activate/index.vue"),
		children: [
			{
				path: "/mactivate/wayBack", // 选择激活账号方式
				name: "wayBack",
				component: () => import("@/views/mViews/activate/WayBack.vue"),
				meta: {
					title: "选择激活账号方式",
					field: "activate_way",
					isShowArrow: true,
					notRequireAuth: true,
				},
			},
			{
				path: "/mactivate/verifyInfo", // 激活信息校验
				name: "VerifyInfo",
				component: () => import("@/views/mViews/activate/VerifyInfo.vue"),
				meta: {
					title: "校验个人信息",
					field: "verify_info_activate",
					isShowArrow: true,
					notRequireAuth: true,
				},
			},
		],
	},
	//绑定账户
	{
		path: "/mbindAccount",
		name: "BindAccount",
		component: () => import("@/views/mViews/home/BindAccount.vue"),
		meta: {
			notRequireAuth: true,
			title: "绑定账户",
			isShowArrow: true,
		},
	},

	// 获取酒城e通token
	{
		path: "/mthirdtoken",
		name: "thirdToken",
		component: () => import("@/views/mViews/thirdToken/index.vue"),
		meta: {
			notRequireAuth: true,
			title: "",
			isShowArrow: false,
		},
	},
];
